import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { AuthService } from 'app/_services/auth.service';
import { Growl } from 'angular/custom/services/growl.service';
import * as angular from 'angular';

class OperatorSettingsGeneralCtrl implements ng.IController {
    public enabledSettings: PossibleSettings[];
    private settings: TsoGeneralSettingsDto;
    public loading: boolean;
    public loadingError: boolean = false;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private authService: AuthService,
        private growl: Growl
    ) {}

    private loginResult: LoginResult;

    $onInit(): void {
        this.loading = true;
        this.authService.userLoginPromise.promise
            .then((loginResult: LoginResult) => {
                this.loginResult = loginResult;
                this.TransmissionSystemOperator.getGeneralSettings(
                    { id: this.loginResult.referenceId },
                    (res: TsoGeneralSettingsDto) => {
                        this.settings = res;
                        this.loading = false;
                        this.loadingError = false;
                    },
                    (err: any) => {
                        this.loading = false;
                        this.loadingError = true;
                        this.growl.show(
                            'Whoops! Something went wrong. Please try again later',
                            'danger'
                        );
                    }
                );
            })
            .catch(() => {
                this.loading = false;
                this.loadingError = true;
                this.growl.show('Permission denied.', 'danger');
            });
    }

    //TODO: Implement this in the story for balancing groups and portfolio codes
    public setBgpc() {}
}

angular.module('app').component('pkpOperatorSettingsGeneral', {
    controller: OperatorSettingsGeneralCtrl,
    template:
        require('app/operator-settings/operator-settings-general.component.html'),
    bindings: {
        balancingGroupPortfolioCodeSelection: '=',
        enabledSettings: '<'
    }
});
